import React from 'react';
import PropTypes from 'prop-types';
import EngineScoringClassificationCategoryListComponent from './EngineScoringClassificationCategoryListComponent';

const EngineScoringClassificationCategoryListContainer = ({
  engineScoringId,
  categories,
  engineClassificationIndex,
  isReadOnly,
  validation,
  dispatch,
  scoringCategoryOptions
}) => {
  return (
    <EngineScoringClassificationCategoryListComponent
      engineScoringId={engineScoringId}
      categories={categories}
      engineClassificationIndex={engineClassificationIndex}
      isReadOnly={isReadOnly}
      scoringCategoryOptions={scoringCategoryOptions}
      dispatch={dispatch}
      validation={validation}
    />
  );
};

EngineScoringClassificationCategoryListContainer.propTypes = {
  engineScoringId: PropTypes.number.isRequired,
  categories: PropTypes.array.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  engineClassificationIndex: PropTypes.number.isRequired,
  validation: PropTypes.object.isRequired,
  scoringCategoryOptions: PropTypes.array.isRequired
};

export default EngineScoringClassificationCategoryListContainer;
